import { Wallet } from '@/features/wallet/components';

export default function WalletPage() {
  return <Wallet />;
}
